module.exports = __webpack_public_path__ + "static/media/image_47.de4a788f.png";